import { render, staticRenderFns } from "./VisualizacaoRelatorio.vue?vue&type=template&id=d5fa58fa&"
import script from "./VisualizacaoRelatorio.vue?vue&type=script&lang=js&"
export * from "./VisualizacaoRelatorio.vue?vue&type=script&lang=js&"
import style0 from "./VisualizacaoRelatorio.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports